import { Injectable, inject } from '@angular/core';

import { AuthService } from '@plugins/client/auth';
import { hasSufficientRoleLevel } from '@plugins/shared/helpers/auth';

/**
 * Client side role information. Affordances only — every write endpoint is
 * guarded server side (PRD §3).
 */
@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private readonly auth = inject(AuthService);

  get isEditor(): boolean {
    const role = this.auth.userToken?.role;

    return !!role && hasSufficientRoleLevel(role, 'editor');
  }
}
